import { api } from './api';

export type DeviceType = 'dhartinetra' | 'weather_station';

export interface IDevice {
    _id: string;
    userId: string;
    type: DeviceType;
    deviceId?: string;
    name?: string;
    cropType?: string;
    district?: string;
    village?: string;
    frequency: 'daily' | 'weekly' | 'alerts';
    preferredLanguage: 'english' | 'hindi' | 'marathi';
    timezone?: string;
    isActive: boolean;
    createdAt: string;
    updatedAt: string;
}

export interface CreateDhartiNetraPayload {
    type: 'dhartinetra';
    deviceId: string;
    name?: string;
    cropType: string;
    frequency: string;
    preferredLanguage: string;
}

export interface CreateWeatherStationPayload {
    type: 'weather_station';
    district: string;
    village: string;
    frequency: string;
    preferredLanguage: string;
}

export type CreateDevicePayload = CreateDhartiNetraPayload | CreateWeatherStationPayload;

export const deviceService = {
    /** List all devices belonging to the logged-in user */
    list: async (): Promise<IDevice[]> => {
        const { data } = await api.get('/devices');
        return data.data;
    },

    /** Register a new DhartiNetra or Weather Station device */
    create: async (payload: CreateDevicePayload): Promise<IDevice> => {
        const { data } = await api.post('/devices', payload);
        return data.data;
    },

    /** Update device settings */
    update: async (id: string, payload: Partial<IDevice>): Promise<IDevice> => {
        const { data } = await api.patch(`/devices/${id}`, payload);
        return data.data;
    },

    /** Soft-delete (deactivate) a device */
    remove: async (id: string): Promise<void> => {
        await api.delete(`/devices/${id}`);
    },
};
